import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import LazyHydrate from 'vue-lazy-hydration';
import { getProductPrice } from '~/utils/ProductPrice';
import MerchandisingLabels from '~/components/Product/MerchandisingLabels.vue';
import TheTabs from '~/components/Layout/Tabs/TheTabs.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzLoader from '~/components/_next/atoms/AzLoader.vue';
import ProductBottomNavigation from '~/components/Product/ProductBottomNavigation.vue';
import SummaryRow from '~/components/Recipe/SummaryRow.vue';
import BaseSingleBreadcrumb from '~/components/Layout/BaseSingleBreadcrumb.vue';
import BaseBreadcrumbs from '~/components/Layout/BaseBreadcrumbs.vue';
import BlockAdviceList from '~/components/cms/custom/BlockAdviceList.vue';
import Gallery from '~/components/Layout/Gallery.vue';
import AzBackToTopButton from '~/components/_next/atoms/AzBackToTopButton.vue';
import AddToCart from '~/components/Layout/Cart/AddToCart/AddToCart.vue';
import ModalAddToCartRDPOrganism from '~/components/_next/organisms/ModalAddToCartRDPOrganism.vue';
import ProductPagePrice from '~/components/Product/ProductPrice/ProductPagePrice.vue';
import KeyBenefits from '~/components/Molecules/KeyBenefits.vue';
import ProductDeliveryMessage from '~/components/Product/ProductDeliveryMessage.vue';
import BlockRecipeList from '~/components/cms/custom/BlockRecipeList.vue';
import BlockCategoryTags from '~/components/cms/custom/BlockCategoryTags.vue';
import StickyAddToCartOverlay from '~/components/Layout/Cart/AddToCart/StickyAddToCartOverlay.vue';
import RatingReviews from '~/components/Layout/consumerAdvice/RatingReviews.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import Tooltip from '~/components/Layout/ToolTip.vue';
import AverageRatingCount from '~/components/Layout/consumerAdvice/AverageRatingCount.vue';
import { recipeIngredientsStore } from '~/store/RecipeIngredientsStore';
import { klaviyoClientPushEvent } from '~/helpers/tracking/klaviyo';
import { centimesToEuros } from '~/helpers/gtm';
import { scrollToReviews } from '~/helpers/reviewsRating';
import useFormatForGallery from '~/composables/galleryContentDataAdapter/useFormatForGallery';
import { useProduct } from '~/composables/_next/useProduct';
import { useUser } from '~/composables/_next/useUser';
import { useGetTranslations } from '~/composables/useGetTranslations';
import useAtc from '~/composables/recipe';
import useKeyBenefits from '~/composables/useKeyBenefits';
import { HEADER_HEIGHT, DESKTOP_WIDTH, SCHEMA_AGGREGATE_RATING, SCHEMA_PRODUCT, NUMBER_OF_REVIEWS, EURO_SYMBOL } from '~/constants';
import { useLocalization } from '~/composables/_next/useLocalization';
export var IRecipe;
export default defineComponent({
  name: 'Recipe',
  transition: 'fade',
  components: {
    AverageRatingCount: AverageRatingCount,
    Tooltip: Tooltip,
    AzImg: AzImg,
    RatingReviews: RatingReviews,
    AzLoader: AzLoader,
    AzIcon: AzIcon,
    LazyHydrate: LazyHydrate,
    Gallery: Gallery,
    BaseSingleBreadcrumb: BaseSingleBreadcrumb,
    BaseBreadcrumbs: BaseBreadcrumbs,
    ProductBottomNavigation: ProductBottomNavigation,
    TheTabs: TheTabs,
    SummaryRow: SummaryRow,
    AzBackToTopButton: AzBackToTopButton,
    AddToCart: AddToCart,
    ModalAddToCartRDPOrganism: ModalAddToCartRDPOrganism,
    ProductPagePrice: ProductPagePrice,
    KeyBenefits: KeyBenefits,
    ProductDeliveryMessage: ProductDeliveryMessage,
    MerchandisingLabels: MerchandisingLabels,
    BlockRecipeList: BlockRecipeList,
    BlockAdviceList: BlockAdviceList,
    BlockCategoryTags: BlockCategoryTags,
    StickyAddToCartOverlay: StickyAddToCartOverlay,
    RecipesWishlistButton: function RecipesWishlistButton() {
      return import('~/components/RecipeWishlist/RecipesWishlistButton.vue');
    }
  },
  props: {
    content: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tabs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    ingredients: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    relatedAdvices: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    parentCategory: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    recipeListing: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    loading: Boolean,
    reviews: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currentPage: {
      type: Number,
      default: 1
    },
    reviewRating: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pagination: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    idProduct: {
      type: String,
      default: ''
    },
    categoryTags: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['update-current-page-index'],
  setup: function setup(props, _ref) {
    var _user$value, _contentResource$valu23, _contentResource$valu24, _contentResource$valu25, _contentResource$valu26;
    var emit = _ref.emit;
    var route = useRoute();
    var hash = computed(function () {
      return route.hash;
    });
    var store = recipeIngredientsStore;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useProduct = useProduct('productIngredients'),
      productIngredients = _useProduct.products,
      searchIngredients = _useProduct.search;
    var _useProduct2 = useProduct('productEquipments'),
      productEquipments = _useProduct2.products,
      searchEquipments = _useProduct2.search;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useUser = useUser(),
      user = _useUser.user,
      isAuthenticated = _useUser.isAuthenticated;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var customerEmail = isAuthenticated.value ? (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.email : '';
    var contentResource = computed(function () {
      return props.content || {};
    });
    var tabsResource = computed(function () {
      return props.tabs;
    });
    var _useKeyBenefits = useKeyBenefits({
        keyBenefitsAttributes: contentResource,
        iconsLibraries: {
          iconLibraryRecipeBenefit: 1,
          iconLibrarySkin: 2,
          libraryHairTypeIcon: 3
        }
      }),
      keyBenefits = _useKeyBenefits.keyBenefits;
    var ingredients = computed(function () {
      return props.ingredients || [];
    });
    var equipmentsWithBalance = computed(function () {
      var _contentResource$valu;
      return (_contentResource$valu = contentResource.value) === null || _contentResource$valu === void 0 ? void 0 : _contentResource$valu.equipmentsWithBalance;
    });
    var equipmentsWithoutBalance = computed(function () {
      var _contentResource$valu2;
      return (_contentResource$valu2 = contentResource.value) === null || _contentResource$valu2 === void 0 ? void 0 : _contentResource$valu2.equipmentsWithoutBalance;
    });
    var recipeID = computed(function () {
      return props.idProduct;
    });
    var recipeSlug = computed(function () {
      var _contentResource$valu3;
      return (_contentResource$valu3 = contentResource.value) === null || _contentResource$valu3 === void 0 ? void 0 : _contentResource$valu3.slug;
    });
    var recipeName = computed(function () {
      var _contentResource$valu4;
      return (_contentResource$valu4 = contentResource.value) === null || _contentResource$valu4 === void 0 ? void 0 : _contentResource$valu4.name;
    });
    var recipeImage = computed(function () {
      var _contentResource$valu5, _contentResource$valu6;
      return ((_contentResource$valu5 = contentResource.value) === null || _contentResource$valu5 === void 0 ? void 0 : _contentResource$valu5.carousel.length) > 0 ? (_contentResource$valu6 = contentResource.value) === null || _contentResource$valu6 === void 0 ? void 0 : _contentResource$valu6.carousel[0].fields.file.url : null;
    });
    var recipeParentFamily = computed(function () {
      var _contentResource$valu7, _contentResource$valu8, _contentResource$valu9, _contentResource$valu0, _contentResource$valu1;
      return ((_contentResource$valu7 = contentResource.value) === null || _contentResource$valu7 === void 0 ? void 0 : (_contentResource$valu8 = _contentResource$valu7.cosmecticRecipeFamily) === null || _contentResource$valu8 === void 0 ? void 0 : _contentResource$valu8.length) > 0 ? (_contentResource$valu9 = contentResource.value) === null || _contentResource$valu9 === void 0 ? void 0 : (_contentResource$valu0 = _contentResource$valu9.cosmecticRecipeFamily[0]) === null || _contentResource$valu0 === void 0 ? void 0 : (_contentResource$valu1 = _contentResource$valu0.fields) === null || _contentResource$valu1 === void 0 ? void 0 : _contentResource$valu1.parentFamily : null;
    });
    var quantity = ref(1);
    var recipePrice = ref();
    provide('quantity', quantity);
    provide('ingredients', ingredients);
    provide('equipmentsWithBalance', equipmentsWithBalance);
    provide('equipmentsWithoutBalance', equipmentsWithoutBalance);
    provide('isRecipePage', true);
    provide('recipeID', recipeID);
    provide('recipeSlug', recipeSlug);
    provide('recipeName', recipeName);
    provide('recipeImage', recipeImage);
    provide('recipeParentFamily', recipeParentFamily);
    var ingredientsSkus = computed(function () {
      return ingredients.value.filter(function (ingredient) {
        var _ingredient$fields;
        return (_ingredient$fields = ingredient.fields) === null || _ingredient$fields === void 0 ? void 0 : _ingredient$fields.ingredientSku;
      }).map(function (ingredient) {
        var _ingredient$fields2;
        return (_ingredient$fields2 = ingredient.fields) === null || _ingredient$fields2 === void 0 ? void 0 : _ingredient$fields2.ingredientSku;
      });
    });
    var combinedEquipment = computed(function () {
      return [].concat(_toConsumableArray(equipmentsWithBalance.value ? _toConsumableArray(equipmentsWithBalance.value) : []), _toConsumableArray(equipmentsWithoutBalance.value ? _toConsumableArray(equipmentsWithoutBalance.value) : []));
    });
    var equipmentSkus = computed(function () {
      return combinedEquipment.value.filter(function (equipment) {
        var _equipment$fields;
        return (_equipment$fields = equipment.fields) === null || _equipment$fields === void 0 ? void 0 : _equipment$fields.equipmentSku;
      }).map(function (equipment) {
        return equipment.fields.equipmentSku;
      });
    });
    useLazyAsyncData('recipe-ingredients', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _ingredientsSkus$valu;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if ((_ingredientsSkus$valu = ingredientsSkus.value) !== null && _ingredientsSkus$valu !== void 0 && _ingredientsSkus$valu.length) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", true);
          case 2:
            _context.next = 4;
            return searchIngredients({
              skus: ingredientsSkus.value
            });
          case 4:
            return _context.abrupt("return", true);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), {
      watch: [ingredientsSkus]
    });
    useLazyAsyncData('recipe-equipments', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _equipmentSkus$value;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if ((_equipmentSkus$value = equipmentSkus.value) !== null && _equipmentSkus$value !== void 0 && _equipmentSkus$value.length) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", true);
          case 2:
            _context2.next = 4;
            return searchEquipments({
              skus: equipmentSkus.value
            });
          case 4:
            return _context2.abrupt("return", true);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), {
      watch: [equipmentSkus]
    });
    /**
     * Filters items by SKU and calculates total prices simultaneously.
     * @param {Array.<{name: string, sku: string, price: {regular: number, special?: number}}>} items - The items to be filtered and for which prices are to be calculated. Each item must have `name`, `sku`, and `price`.
     * @param {string[]} skus - The SKUs to filter by.
     * @returns {Object} - The filtered items, the SKUs not found, and the calculated total prices.
     */
    function filterAndCalculatePrice(items, skus) {
      var totalRegular = 0;
      var totalSpecial = 0;
      var hasSpecialPrice = false;
      var _iterator = _createForOfIteratorHelper(items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var skuIndex = skus.indexOf(item.sku);
          if (skuIndex > -1) {
            var price = getProductPrice(item);
            totalRegular += price.regular;
            if (price.special) {
              totalSpecial += price.special;
              hasSpecialPrice = true;
            } else {
              totalSpecial += price.regular;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var roundToTwoDecimals = function roundToTwoDecimals(num) {
        return parseFloat(num.toFixed(2));
      };
      var allPrice = {
        regular: roundToTwoDecimals(totalRegular),
        special: hasSpecialPrice ? roundToTwoDecimals(totalSpecial) : null
      };
      var formatPrice = function formatPrice(price) {
        return "".concat(price.toFixed(2).replace('.', ','), " ").concat(EURO_SYMBOL);
      }; // Assurez-vous que EURO_SYMBOL est défini quelque part dans votre code
      var totalRegularStr = totalRegular ? formatPrice(totalRegular) : null;
      var totalSpecialStr = hasSpecialPrice ? formatPrice(totalSpecial) : null;
      return {
        regular: totalRegularStr,
        special: totalSpecialStr,
        allPriceInNumber: allPrice
      };
    }
    var setIngredients = function setIngredients() {
      store.setIngredients(productIngredients.value);
    };
    var setEquipmentProducts = function setEquipmentProducts() {
      store.setEquipmentProducts(productEquipments.value);
    };
    setIngredients();
    setEquipmentProducts();
    var ingredientsLoading = ref(false);
    var equipmentLoading = ref(false);
    watch(ingredientsSkus, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            ingredientsLoading.value = true;
            _context3.next = 3;
            return searchIngredients({
              skus: ingredientsSkus.value
            });
          case 3:
            setIngredients();
            ingredientsLoading.value = false;
            recipePrice.value = filterAndCalculatePrice(productIngredients.value, ingredientsSkus.value);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    watch(equipmentSkus, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            equipmentLoading.value = true;
            _context4.next = 3;
            return searchEquipments({
              skus: equipmentSkus.value
            });
          case 3:
            setEquipmentProducts();
            equipmentLoading.value = false;
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })));
    onUnmounted(function () {
      return store.reset();
    });
    var productGallery = computed(function () {
      var _contentResource$valu10;
      return useFormatForGallery(contentResource === null || contentResource === void 0 ? void 0 : (_contentResource$valu10 = contentResource.value) === null || _contentResource$valu10 === void 0 ? void 0 : _contentResource$valu10.carousel);
    });
    var mainImageUrl = computed(function () {
      var _ref6, _productGallery$value, _productGallery$value2, _productGallery$value3, _productGallery$value4, _productGallery$value5, _productGallery$value6;
      return (_ref6 = (_productGallery$value = (_productGallery$value2 = productGallery.value) === null || _productGallery$value2 === void 0 ? void 0 : (_productGallery$value3 = _productGallery$value2[0]) === null || _productGallery$value3 === void 0 ? void 0 : (_productGallery$value4 = _productGallery$value3.mobile) === null || _productGallery$value4 === void 0 ? void 0 : _productGallery$value4.url) !== null && _productGallery$value !== void 0 ? _productGallery$value : (_productGallery$value5 = productGallery.value) === null || _productGallery$value5 === void 0 ? void 0 : (_productGallery$value6 = _productGallery$value5[0]) === null || _productGallery$value6 === void 0 ? void 0 : _productGallery$value6.url) !== null && _ref6 !== void 0 ? _ref6 : '';
    });
    var capacityToCreate = computed(function () {
      var _contentResource$valu11, _contentResource$valu12, _contentResource$valu13;
      return (_contentResource$valu11 = contentResource.value) === null || _contentResource$valu11 === void 0 ? void 0 : (_contentResource$valu12 = _contentResource$valu11.capacityToUseForAddToCart) === null || _contentResource$valu12 === void 0 ? void 0 : (_contentResource$valu13 = _contentResource$valu12.fields) === null || _contentResource$valu13 === void 0 ? void 0 : _contentResource$valu13.quantityToCreate;
    });
    provide('capacityToCreate', capacityToCreate);
    var isSticky = ref(false);
    var isNeedDesktopStickyAddToCart = ref(false);
    var addToCartElement = ref(null);
    var productRef = ref(null);
    var scrollFunc = function scrollFunc() {
      var _addToCartElement$val, _addToCartElement$val2, _addToCartElement$val3, _addToCartElement$val4, _productRef$value, _productRef$value2, _window, _window2;
      isSticky.value = ((_addToCartElement$val = addToCartElement.value) === null || _addToCartElement$val === void 0 ? void 0 : (_addToCartElement$val2 = _addToCartElement$val.$el) === null || _addToCartElement$val2 === void 0 ? void 0 : _addToCartElement$val2.clientHeight) + ((_addToCartElement$val3 = addToCartElement.value) === null || _addToCartElement$val3 === void 0 ? void 0 : (_addToCartElement$val4 = _addToCartElement$val3.$el) === null || _addToCartElement$val4 === void 0 ? void 0 : _addToCartElement$val4.offsetTop) < window.scrollY && window.screen.width < DESKTOP_WIDTH;
      isNeedDesktopStickyAddToCart.value = ((_productRef$value = productRef.value) === null || _productRef$value === void 0 ? void 0 : _productRef$value.clientHeight) + ((_productRef$value2 = productRef.value) === null || _productRef$value2 === void 0 ? void 0 : _productRef$value2.offsetTop) + HEADER_HEIGHT < ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollY) && ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.screen.width) > DESKTOP_WIDTH;
    };
    var breadcrumbs = computed(function () {
      var _props$recipeListing, _props$recipeListing2, _props$recipeListing3, _props$recipeListing4, _contentResource$valu14, _contentResource$valu15;
      return [{
        link: app.localePath({
          name: 'index'
        }),
        text: translate('utils.homeBreadcrumbs')
      }].concat(_toConsumableArray((_props$recipeListing = props.recipeListing) !== null && _props$recipeListing !== void 0 && _props$recipeListing.title && (_props$recipeListing2 = props.recipeListing) !== null && _props$recipeListing2 !== void 0 && _props$recipeListing2.slug ? [{
        link: app.localePath("/recipes/".concat((_props$recipeListing3 = props.recipeListing) === null || _props$recipeListing3 === void 0 ? void 0 : _props$recipeListing3.slug)),
        text: (_props$recipeListing4 = props.recipeListing) === null || _props$recipeListing4 === void 0 ? void 0 : _props$recipeListing4.title
      }] : []), [{
        link: app.localePath("/recipe/".concat((_contentResource$valu14 = contentResource.value) === null || _contentResource$valu14 === void 0 ? void 0 : _contentResource$valu14.slug)),
        text: (_contentResource$valu15 = contentResource.value) === null || _contentResource$valu15 === void 0 ? void 0 : _contentResource$valu15.title
      }]);
    });
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            window.addEventListener('scroll', scrollFunc);
            window.scrollTo(0, 0);
            if (hash.value) {
              setTimeout(function () {
                scrollToReviews(hash.value);
              }, 2000);
            }
            recipePrice.value = filterAndCalculatePrice(productIngredients.value, ingredientsSkus.value);
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })));
    onUnmounted(function () {
      window.removeEventListener('scroll', scrollFunc);
    });
    var merchLabels = computed(function () {
      var _contentResource$valu16, _contentResource$valu17, _contentResource$valu18, _contentResource$valu19, _contentResource$valu20;
      var labels = {};
      labels.recipeTypeV2 = contentResource === null || contentResource === void 0 ? void 0 : (_contentResource$valu16 = contentResource.value) === null || _contentResource$valu16 === void 0 ? void 0 : (_contentResource$valu17 = _contentResource$valu16.recipeTypeV2) === null || _contentResource$valu17 === void 0 ? void 0 : (_contentResource$valu18 = _contentResource$valu17.fields) === null || _contentResource$valu18 === void 0 ? void 0 : _contentResource$valu18.name;
      if (((_contentResource$valu19 = contentResource.value) === null || _contentResource$valu19 === void 0 ? void 0 : (_contentResource$valu20 = _contentResource$valu19.cosmecticRecipeFamily) === null || _contentResource$valu20 === void 0 ? void 0 : _contentResource$valu20.length) > 0) {
        var _contentResource$valu21, _contentResource$valu22;
        labels.recipeFamily = (_contentResource$valu21 = contentResource.value.cosmecticRecipeFamily[0]) === null || _contentResource$valu21 === void 0 ? void 0 : (_contentResource$valu22 = _contentResource$valu21.fields) === null || _contentResource$valu22 === void 0 ? void 0 : _contentResource$valu22.title;
      }
      return labels;
    });
    var storeEquipment = toRef(recipeIngredientsStore, 'equipmentProducts');
    var storeIngredients = toRef(recipeIngredientsStore, 'ingredients');
    var _useAtc = useAtc({
        quantity: ref(1),
        capacityToCreate: capacityToCreate,
        equipment: storeEquipment,
        ingredients: storeIngredients,
        ingredientsConfig: ingredients,
        state: ref('ingredients'),
        slug: (_contentResource$valu23 = contentResource.value) === null || _contentResource$valu23 === void 0 ? void 0 : _contentResource$valu23.slug,
        id: props.idProduct,
        name: (_contentResource$valu24 = contentResource.value) === null || _contentResource$valu24 === void 0 ? void 0 : _contentResource$valu24.name,
        image: (_contentResource$valu25 = contentResource.value) === null || _contentResource$valu25 === void 0 ? void 0 : _contentResource$valu25.image,
        parentFamily: (_contentResource$valu26 = contentResource.value) === null || _contentResource$valu26 === void 0 ? void 0 : _contentResource$valu26.parentFamily
      }),
      total = _useAtc.total,
      products = _useAtc.products;

    // Checks if we are currently waiting for any requests (that for example have effect on price calculation), so we can know when to dispaly fully loaded page
    var recipeLoading = computed(function () {
      return props.loading || ingredientsLoading.value || equipmentLoading.value;
    });
    var title = computed(function () {
      var _contentResource$valu27;
      return ((_contentResource$valu27 = contentResource.value) === null || _contentResource$valu27 === void 0 ? void 0 : _contentResource$valu27.title) || '';
    });
    watch(function () {
      return recipeLoading.value;
    }, function () {
      if (!recipeLoading.value) {
        if (customerEmail) {
          var _contentResource$valu28, _total$value, _total$value$value;
          var recipeItems = '';
          if (products.value.length > 0) {
            recipeItems = products.value.map(function (item) {
              var _item$price, _item$price$value, _item$price2, _item$price2$discount, _item$price2$discount2;
              return {
                ProductId: item._id,
                ProductSku: item.sku,
                ItemPrice: centimesToEuros((_item$price = item.price) === null || _item$price === void 0 ? void 0 : (_item$price$value = _item$price.value) === null || _item$price$value === void 0 ? void 0 : _item$price$value.centAmount),
                ItemPriceDiscount: centimesToEuros((_item$price2 = item.price) === null || _item$price2 === void 0 ? void 0 : (_item$price2$discount = _item$price2.discount) === null || _item$price2$discount === void 0 ? void 0 : (_item$price2$discount2 = _item$price2$discount.value) === null || _item$price2$discount2 === void 0 ? void 0 : _item$price2$discount2.centAmount) || ''
              };
            });
          }
          var AddedProperties = {
            RecipeName: (_contentResource$valu28 = contentResource.value) === null || _contentResource$valu28 === void 0 ? void 0 : _contentResource$valu28.title,
            ImageUrl: mainImageUrl.value || '',
            Price: centimesToEuros((_total$value = total.value) === null || _total$value === void 0 ? void 0 : (_total$value$value = _total$value.value) === null || _total$value$value === void 0 ? void 0 : _total$value$value.centAmount) || '',
            items: recipeItems
          };
          klaviyoClientPushEvent(customerEmail, locale, AddedProperties, 'Viewed recipe');
        }
      }
      if (hash.value) {
        setTimeout(function () {
          scrollToReviews(hash === null || hash === void 0 ? void 0 : hash.value);
        }, 1000);
      }
    });
    var relatedRecipes = computed(function () {
      var _contentResource$valu29, _contentResource$valu30;
      var recipes = (_contentResource$valu29 = contentResource.value) === null || _contentResource$valu29 === void 0 ? void 0 : (_contentResource$valu30 = _contentResource$valu29.associatedRecipes) === null || _contentResource$valu30 === void 0 ? void 0 : _contentResource$valu30.fields;
      if (recipes) {
        var _recipes$listOfRecipe;
        var listOfRecipes = recipes === null || recipes === void 0 ? void 0 : (_recipes$listOfRecipe = recipes.listOfRecipes) === null || _recipes$listOfRecipe === void 0 ? void 0 : _recipes$listOfRecipe.filter(function (recipe) {
          return recipe === null || recipe === void 0 ? void 0 : recipe.fields;
        });
        return {
          title: recipes.title,
          description: recipes.description,
          listOfRecipes: listOfRecipes
        };
      }
      return null;
    });
    var isAllIngredientsOutOfStock = computed(function () {
      var _products$value;
      return !recipeLoading.value && ((_products$value = products.value) === null || _products$value === void 0 ? void 0 : _products$value.every(function (_ref8) {
        var outOfStock = _ref8.outOfStock;
        return outOfStock;
      }));
    });
    var isSomeIngredientsOutOfStock = computed(function () {
      var _products$value2;
      return !isAllIngredientsOutOfStock.value && ((_products$value2 = products.value) === null || _products$value2 === void 0 ? void 0 : _products$value2.some(function (_ref9) {
        var outOfStock = _ref9.outOfStock;
        return outOfStock;
      }));
    });
    function updateCurrentPage(newPage) {
      emit('update-current-page-index', newPage);
    }

    /**
     * Toggles the add to cart modal
     * Using pure js as the element is in another component.
     */
    function toggleAddToCartModal() {
      var modal = document.querySelector('dialog.modal-add-to-cart-rdp');
      if (modal !== null && modal !== void 0 && modal.open) {
        modal.close();
      } else {
        modal.showModal();
      }
    }
    return {
      recipePrice: recipePrice,
      SCHEMA_AGGREGATE_RATING: SCHEMA_AGGREGATE_RATING,
      SCHEMA_PRODUCT: SCHEMA_PRODUCT,
      title: title,
      contentResource: contentResource,
      tabsResource: tabsResource,
      productGallery: productGallery,
      translate: translate,
      quantity: quantity,
      total: total,
      addToCartElement: addToCartElement,
      isSticky: isSticky,
      keyBenefits: keyBenefits,
      breadcrumbs: breadcrumbs,
      merchLabels: merchLabels,
      recipeLoading: recipeLoading,
      relatedRecipes: relatedRecipes,
      isSomeIngredientsOutOfStock: isSomeIngredientsOutOfStock,
      isAllIngredientsOutOfStock: isAllIngredientsOutOfStock,
      isNeedDesktopStickyAddToCart: isNeedDesktopStickyAddToCart,
      productRef: productRef,
      mainImageUrl: mainImageUrl,
      updateCurrentPage: updateCurrentPage,
      isMobile: isMobile,
      NUMBER_OF_REVIEWS: NUMBER_OF_REVIEWS,
      toggleAddToCartModal: toggleAddToCartModal
    };
  }
});